/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ImageDTO } from "./ImageDTO";
import { ImageDTOFromJSON, ImageDTOFromJSONTyped, ImageDTOToJSON } from "./ImageDTO";
import type { OutDealDTO } from "./OutDealDTO";
import { OutDealDTOFromJSON, OutDealDTOFromJSONTyped, OutDealDTOToJSON } from "./OutDealDTO";
import type { PublicPlatformDTO } from "./PublicPlatformDTO";
import {
  PublicPlatformDTOFromJSON,
  PublicPlatformDTOFromJSONTyped,
  PublicPlatformDTOToJSON
} from "./PublicPlatformDTO";
import type { SeoDTO } from "./SeoDTO";
import { SeoDTOFromJSON, SeoDTOFromJSONTyped, SeoDTOToJSON } from "./SeoDTO";

/**
 *
 * @export
 * @interface OutAdminProductExtendedViewDTO
 */
export interface OutAdminProductExtendedViewDTO {
  /**
   *
   * @type {number}
   * @memberof OutAdminProductExtendedViewDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  ean?: string;
  /**
   *
   * @type {PublicPlatformDTO}
   * @memberof OutAdminProductExtendedViewDTO
   */
  platform: PublicPlatformDTO;
  /**
   *
   * @type {boolean}
   * @memberof OutAdminProductExtendedViewDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  slug: string;
  /**
   *
   * @type {ImageDTO}
   * @memberof OutAdminProductExtendedViewDTO
   */
  image?: ImageDTO;
  /**
   *
   * @type {SeoDTO}
   * @memberof OutAdminProductExtendedViewDTO
   */
  seo?: SeoDTO;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  specification?: string;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductExtendedViewDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  createdAt?: string;
  /**
   * How the page was created (API = automatic sync).
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  createdBy: OutAdminProductExtendedViewDTOCreatedByEnum;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductExtendedViewDTO
   */
  noDealsSince?: Date | null;
  /**
   * When this live page will be taken offline (noDealsSince + grace). Null when not heading offline.
   * @type {Date}
   * @memberof OutAdminProductExtendedViewDTO
   */
  offlineAt?: Date | null;
  /**
   * When this offline automatic page will be deleted (noDealsSince + 90d). Null when not applicable.
   * @type {Date}
   * @memberof OutAdminProductExtendedViewDTO
   */
  deleteAt?: Date | null;
  /**
   * Who wrote the description. MANUAL locks it: the generator skips the row.
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  descriptionSource?: OutAdminProductExtendedViewDTODescriptionSourceEnum;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductExtendedViewDTO
   */
  descriptionGeneratedAt?: Date | null;
  /**
   * The model's own 0–1 certainty for the stored description.
   * @type {number}
   * @memberof OutAdminProductExtendedViewDTO
   */
  descriptionConfidence?: number | null;
  /**
   *
   * @type {Date}
   * @memberof OutAdminProductExtendedViewDTO
   */
  descriptionAttemptedAt?: Date | null;
  /**
   * Why the last generation attempt stored nothing.
   * @type {string}
   * @memberof OutAdminProductExtendedViewDTO
   */
  descriptionSkipReason?: OutAdminProductExtendedViewDTODescriptionSkipReasonEnum;
  /**
   *
   * @type {Array<OutDealDTO>}
   * @memberof OutAdminProductExtendedViewDTO
   */
  deals?: Array<OutDealDTO>;
}

/**
 * @export
 */
export const OutAdminProductExtendedViewDTOCreatedByEnum = {
  API: "API",
  DASHBOARD: "DASHBOARD"
} as const;
export type OutAdminProductExtendedViewDTOCreatedByEnum =
  typeof OutAdminProductExtendedViewDTOCreatedByEnum[keyof typeof OutAdminProductExtendedViewDTOCreatedByEnum];

/**
 * @export
 */
export const OutAdminProductExtendedViewDTODescriptionSourceEnum = {
  MANUAL: "MANUAL",
  AI: "AI"
} as const;
export type OutAdminProductExtendedViewDTODescriptionSourceEnum =
  typeof OutAdminProductExtendedViewDTODescriptionSourceEnum[keyof typeof OutAdminProductExtendedViewDTODescriptionSourceEnum];

/**
 * @export
 */
export const OutAdminProductExtendedViewDTODescriptionSkipReasonEnum = {
  LOW_CONFIDENCE: "LOW_CONFIDENCE",
  BAD_LENGTH: "BAD_LENGTH",
  API_ERROR: "API_ERROR"
} as const;
export type OutAdminProductExtendedViewDTODescriptionSkipReasonEnum =
  typeof OutAdminProductExtendedViewDTODescriptionSkipReasonEnum[keyof typeof OutAdminProductExtendedViewDTODescriptionSkipReasonEnum];

/**
 * Check if a given object implements the OutAdminProductExtendedViewDTO interface.
 */
export function instanceOfOutAdminProductExtendedViewDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "slug" in value;
  isInstance = isInstance && "createdBy" in value;

  return isInstance;
}

export function OutAdminProductExtendedViewDTOFromJSON(json: any): OutAdminProductExtendedViewDTO {
  return OutAdminProductExtendedViewDTOFromJSONTyped(json, false);
}

export function OutAdminProductExtendedViewDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OutAdminProductExtendedViewDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    title: json["title"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    platform: PublicPlatformDTOFromJSON(json["platform"]),
    live: json["live"],
    slug: json["slug"],
    image: !exists(json, "image") ? undefined : ImageDTOFromJSON(json["image"]),
    seo: !exists(json, "seo") ? undefined : SeoDTOFromJSON(json["seo"]),
    description: !exists(json, "description") ? undefined : json["description"],
    specification: !exists(json, "specification") ? undefined : json["specification"],
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    createdAt: !exists(json, "createdAt") ? undefined : json["createdAt"],
    createdBy: json["createdBy"],
    noDealsSince: !exists(json, "noDealsSince")
      ? undefined
      : json["noDealsSince"] === null
      ? null
      : new Date(json["noDealsSince"]),
    offlineAt: !exists(json, "offlineAt") ? undefined : json["offlineAt"] === null ? null : new Date(json["offlineAt"]),
    deleteAt: !exists(json, "deleteAt") ? undefined : json["deleteAt"] === null ? null : new Date(json["deleteAt"]),
    descriptionSource: !exists(json, "descriptionSource") ? undefined : json["descriptionSource"],
    descriptionGeneratedAt: !exists(json, "descriptionGeneratedAt")
      ? undefined
      : json["descriptionGeneratedAt"] === null
      ? null
      : new Date(json["descriptionGeneratedAt"]),
    descriptionConfidence: !exists(json, "descriptionConfidence") ? undefined : json["descriptionConfidence"],
    descriptionAttemptedAt: !exists(json, "descriptionAttemptedAt")
      ? undefined
      : json["descriptionAttemptedAt"] === null
      ? null
      : new Date(json["descriptionAttemptedAt"]),
    descriptionSkipReason: !exists(json, "descriptionSkipReason") ? undefined : json["descriptionSkipReason"],
    deals: !exists(json, "deals") ? undefined : (json["deals"] as Array<any>).map(OutDealDTOFromJSON)
  };
}

export function OutAdminProductExtendedViewDTOToJSON(value?: OutAdminProductExtendedViewDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    title: value.title,
    ean: value.ean,
    platform: PublicPlatformDTOToJSON(value.platform),
    live: value.live,
    slug: value.slug,
    image: ImageDTOToJSON(value.image),
    seo: SeoDTOToJSON(value.seo),
    description: value.description,
    specification: value.specification,
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    createdAt: value.createdAt,
    createdBy: value.createdBy,
    noDealsSince:
      value.noDealsSince === undefined
        ? undefined
        : value.noDealsSince === null
        ? null
        : value.noDealsSince.toISOString(),
    offlineAt:
      value.offlineAt === undefined ? undefined : value.offlineAt === null ? null : value.offlineAt.toISOString(),
    deleteAt: value.deleteAt === undefined ? undefined : value.deleteAt === null ? null : value.deleteAt.toISOString(),
    descriptionSource: value.descriptionSource,
    descriptionGeneratedAt:
      value.descriptionGeneratedAt === undefined
        ? undefined
        : value.descriptionGeneratedAt === null
        ? null
        : value.descriptionGeneratedAt.toISOString(),
    descriptionConfidence: value.descriptionConfidence,
    descriptionAttemptedAt:
      value.descriptionAttemptedAt === undefined
        ? undefined
        : value.descriptionAttemptedAt === null
        ? null
        : value.descriptionAttemptedAt.toISOString(),
    descriptionSkipReason: value.descriptionSkipReason,
    deals: value.deals === undefined ? undefined : (value.deals as Array<any>).map(OutDealDTOToJSON)
  };
}
